import { Action } from '@ngrx/store';
import { Address, SectorPolygon, Street, WeekOfYear } from '../../domain/models';
import { StopDistributionReasonDto } from '../../domain/models/stop-distribution-reason-dto';
import { DistributionViewModel } from '../view-models/distribution.view-model';
import { DistributionListItemViewModel } from '../view-models/distribution-list-item.view-model';
import { DistributionTiming } from '../../domain/enums/distribution-timing';
import { TrackingData } from '../../domain/models/tracking/tracking_data';
import { DistributionStreet } from '../../domain/models/distribution/street';
import { DistributionAddress } from '../../domain/models/distribution/distribution-address';
import { SearchData } from '../../../../../libs/map/components/search-popup/search-data';

export const FILTER_DISTRIBUTIONS: string = '[Distribution] Filter distributions';
export const LOAD_DISTRIBUTIONS: string = '[Distribution] Load distributions';
export const LOAD_DISTRIBUTIONS_SUCCESS: string = '[Distribution] Load distributions successful';
export const LOAD_DISTRIBUTIONS_FAILED: string = '[Distribution] Load distributions failed';
export const LOAD_DISTRIBUTION_DETAIL: string = '[Distribution] Load distribution detail';
export const LOAD_DISTRIBUTION_DETAIL_SUCCESS: string = '[Distribution] Load distribution detail successful';
export const LOAD_DISTRIBUTION_DETAIL_FAILED: string = '[Distribution] Load distribution detail failed';
export const SHOW_EARLY_LATE: string = '[Distribution] Toggle show early late streets';
export const FILTER_STREETS_ON_DISTRIBUTION: string = '[Distribution[ Filter streets on distribution';
export const START_DISTRIBUTION: string = '[Distribution] Start distribution';
export const START_DISTRIBUTION_SUCCESS: string = '[Distribution] Start distribution successful';
export const START_DISTRIBUTION_FAILED: string = '[Distribution] Start distribution failed';
export const STOP_DISTRIBUTION: string = '[Distribution] Stop distribution';
export const STOP_DISTRIBUTION_SUCCESS: string = '[Distribution] Stop distribution successful';
export const STOP_DISTRIBUTION_FAILED: string = '[Distribution] Stop distribution failed';
export const LOAD_TRACKING_DATA: string = '[Distribution] Load tracking data';
export const LOAD_TRACKING_DATA_SUCCESS: string = '[Distribution] Load tracking data success';
export const LOAD_TRACKING_DATA_FAILED: string = '[Distribution] Load tracking data failed';
export const TOGGLE_SHOW_ALL_DEVICES: string = '[Distribution] Toggle show all devices';
export const TOGGLE_SHOW_ICONS: string = '[Distribution] Toggle show icons';
export const TOGGLE_SHOW_DISTRIBUTION: string = '[Distribution] Toggle show distribution';
export const TOGGLE_DEVICE_CHANGED: string = '[Distribution] Toggle device changed';
export const SET_IN_SEARCH_MODE: string = '[Distribution] Set in search mode';

export class FilterDistributions implements Action {
    readonly type: string = FILTER_DISTRIBUTIONS;
    constructor(public payload: string[]) { }
}
export class LoadDistributions implements Action {
    readonly type: string = LOAD_DISTRIBUTIONS;
    constructor(public payload: number) { }
}
export class LoadDistributionsSuccess implements Action {
    readonly type: string = LOAD_DISTRIBUTIONS_SUCCESS;
    constructor(public payload: DistributionListItemViewModel[]) { }
}
export class LoadDistributionsFailed implements Action {
    readonly type: string = LOAD_DISTRIBUTIONS_FAILED;
}
export class LoadDistributionDetail implements Action {
    readonly type: string = LOAD_DISTRIBUTION_DETAIL;
    constructor(public payload: string) { }
}
export class LoadDistributionDetailSuccess implements Action {
    readonly type: string = LOAD_DISTRIBUTION_DETAIL_SUCCESS;
    constructor(public payload: DistributionViewModel) { }
}
export class LoadDistributionDetailFailed implements Action {
    readonly type: string = LOAD_DISTRIBUTION_DETAIL_FAILED;
}

export class LoadTrackingData implements Action {
    readonly type: string = LOAD_TRACKING_DATA;
    constructor(public payload: string) { }
}
export class LoadTrackingDataSuccess implements Action {
    readonly type: string = LOAD_TRACKING_DATA_SUCCESS;
    constructor(public payload: TrackingData) { }
}
export class LoadTrackingDataFailed implements Action {
    readonly type: string = LOAD_TRACKING_DATA_FAILED;
}

export class StartDistribution implements Action {
    readonly type: string = START_DISTRIBUTION;
    constructor(public payload: string) { }
}
export class StartDistributionSuccess implements Action {
    readonly type: string = START_DISTRIBUTION_SUCCESS;
    constructor(public payload: string) { }
}
export class StartDistributionFailed implements Action {
    readonly type: string = START_DISTRIBUTION_FAILED;
}

export class StopDistribution implements Action {
    readonly type: string = STOP_DISTRIBUTION;
    constructor(public payload: StopDistributionReasonDto) { }
}
export class StopDistributionSuccess implements Action {
    readonly type: string = STOP_DISTRIBUTION_SUCCESS;
    constructor(public payload: string) { }
}
export class StopDistributionFailed implements Action {
    readonly type: string = STOP_DISTRIBUTION_FAILED;
}

export class ToggleShowAllDevices implements Action {
    readonly type: string = TOGGLE_SHOW_ALL_DEVICES;
    constructor(public payload: boolean) { }
}
export class ToggleShowIcons implements Action {
    readonly type: string = TOGGLE_SHOW_ICONS;
    constructor(public payload: boolean) { }
}
export class ToggleShowDistribution implements Action {
    readonly type: string = TOGGLE_SHOW_DISTRIBUTION;
    constructor(public payload: boolean) { }
}
export class ToggleDeviceChanged implements Action {
    readonly type: string = TOGGLE_DEVICE_CHANGED;
    constructor(public payload: any) { }
}

type DistributionActions = FilterDistributions &
    LoadDistributions & LoadDistributionsSuccess & LoadDistributionsFailed &
    LoadTrackingData & LoadTrackingDataSuccess & LoadTrackingDataFailed &
    LoadDistributionDetail & LoadDistributionDetailSuccess & LoadDistributionDetailFailed &
    ToggleShowAllDevices & ToggleShowDistribution & ToggleShowIcons & ToggleDeviceChanged &
    StartDistribution & StartDistributionSuccess & StartDistributionFailed & StopDistribution & StopDistributionSuccess & StopDistributionFailed;

export const SET_FEATURE_THRESHOLD: string = '[Map] Set feature threshold';
export const SET_MAP_EXPANSION: string = '[Map] Set map expansion';
export const TOGGLE_MAP: string = '[Map] Toggle map';

export class SetFeatureThreshold implements Action {
    readonly type: string = SET_FEATURE_THRESHOLD;
    constructor(public payload: number) { }
}
export class SetMapExpansion implements Action {
    readonly type: string = SET_MAP_EXPANSION;
    constructor(public payload: boolean) { }
}
export class ToggleMap implements Action {
    readonly type: string = TOGGLE_MAP;
}

type MapActions = SetFeatureThreshold & SetMapExpansion & ToggleMap;

export const LOAD_SECTORS: string = '[Sector] Load sectors';
export const LOAD_SECTORS_SUCCESS: string = '[Sector] Load sectors successful';
export const LOAD_SECTORS_FAILED: string = '[Sector] Load sectors failed';
export const LOAD_STREETS: string = '[Sector] Load streets';
export const LOAD_STREETS_SUCCESS: string = '[Sector] Load streets successful';
export const LOAD_STREETS_FAILED: string = '[Sector] Load streets failed';
export const LOAD_ADDRESSES: string = '[Sector] Load addresses';
export const LOAD_ADDRESSES_SUCCESS: string = '[Sector] Load addresses successful';
export const LOAD_ADDRESSES_FAILED: string = '[Sector] Load addresses failed';
export const SET_SEARCH_DATA: string = '[Sector] Set search data';
export const SHOW_UPDATE_POPUP: string = '[Sector] Show update popup';
export const CLOSE_POPUP: string = '[Sector] Close popup';

export class LoadSectors implements Action {
    readonly type: string = LOAD_SECTORS;
    constructor(public payload: string[]) { }
}
export class LoadSectorsSuccess implements Action {
    readonly type: string = LOAD_SECTORS_SUCCESS;
    constructor(public payload: SectorPolygon[]) { }
}
export class LoadSectorsFailed implements Action {
    readonly type: string = LOAD_SECTORS_FAILED;
}
export class LoadStreets implements Action {
    readonly type: string = LOAD_STREETS;
    constructor(public distributionStreets: DistributionStreet[], public sectorId: string) { }
}
export class LoadStreetsSuccess implements Action {
    readonly type: string = LOAD_STREETS_SUCCESS;
    constructor(public distributionStreets: DistributionStreet[], public streets: Street[]) { }
}
export class LoadStreetsFailed implements Action {
    readonly type: string = LOAD_STREETS_FAILED;
}
export class LoadAddresses implements Action {
    readonly type: string = LOAD_ADDRESSES;
    constructor(public distributionAddresses: DistributionAddress[], public sectorId: string) { }
}
export class LoadAddressesSuccess implements Action {
    readonly type: string = LOAD_ADDRESSES_SUCCESS;
    constructor(public distributionAddresses: DistributionAddress[], public addresses: Address[]) { }
}
export class LoadAddressesFailed implements Action {
    readonly type: string = LOAD_ADDRESSES_FAILED;
}

export class ShowEarlyLate implements Action {
    readonly type: string = SHOW_EARLY_LATE;
    constructor(public payload: boolean) { }
}
export class FilterStreetsOnDistribution implements Action {
    readonly type: string = FILTER_STREETS_ON_DISTRIBUTION;
    constructor(public payload: DistributionTiming) { }
}

export class SetInSearchMode implements Action {
    readonly type: string = SET_IN_SEARCH_MODE;
    constructor(public payload: boolean) { }
}
export class SetSearchData implements Action {
    readonly type: string = SET_SEARCH_DATA;
    constructor(public payload: SearchData) { }
}
export class ShowUpdatePopup implements Action {
    readonly type: string = SHOW_UPDATE_POPUP;
    constructor(public payload: string[]) { }
}
export class ClosePopup implements Action {
    readonly type: string = CLOSE_POPUP;
    constructor(public payload: any) { }
}

type SectorActions = LoadSectors & LoadSectorsSuccess & LoadSectorsFailed &
    LoadStreets & LoadStreetsSuccess & LoadStreetsFailed &
    LoadAddresses & LoadAddressesSuccess & LoadAddressesFailed &
    ShowEarlyLate & FilterStreetsOnDistribution & SetInSearchMode;

export const CLOSE_ERROR_DIALOG: string = '[UI] Close error dialog';
export const SELECT_DEVICE: string = '[UI] Select device';
export const SELECT_DISTRIBUTION: string = '[UI] Select sector';

export class CloseErrorDialog implements Action {
    readonly type: string = CLOSE_ERROR_DIALOG;
}
export class SelectDevice implements Action {
    readonly type: string = SELECT_DEVICE;
    constructor(public payload: string) { }
}
export class SelectDistribution implements Action {
    readonly type: string = SELECT_DISTRIBUTION;
    constructor(public payload: DistributionListItemViewModel) { }
}

type UiActions = CloseErrorDialog & SelectDevice & SelectDistribution;

export const LOAD_WEEKS: string = '[Week] Load weeks';
export const LOAD_WEEKS_COMPLETED: string = '[Week] Load weeks completed';
export const SET_ACTIVE_WEEK: string = '[Week] Set active week';

export class LoadWeeks implements Action {
    readonly type: string = LOAD_WEEKS;
}
export class LoadWeeksCompleted implements Action {
    readonly type: string = LOAD_WEEKS_COMPLETED;
    constructor(public payload: WeekOfYear[]) { }
}
export class SetActiveWeek implements Action {
    readonly type: string = SET_ACTIVE_WEEK;
    constructor(public payload: number) { }
}

type WeekActions = LoadWeeks & LoadWeeksCompleted & SetActiveWeek;

export type All = DistributionActions & MapActions & SectorActions & UiActions & WeekActions;



// WEBPACK FOOTER //
// ./src/app/modules/distribution/store/distribution.actions.ts